import { forwardRef } from 'react';
import { Button } from '@mui/material';
import { IOutlinedButton } from 'types/atoms';

const COutlinedPrimaryButton = forwardRef<HTMLButtonElement, IOutlinedButton>((props, ref) => {
  return (
    <Button
      {...props}
      ref={ref}
      variant="outlined"
      classes={{
        root: 'rounded-xl border-2 border-primary-200 px-[14px] py-1 text-body16 normal-case text-primary-500 hover:border-2 hover:border-primary-300 hover:bg-primary-0 hover:text-primary-600 disabled:border-neutral-200',
        startIcon: 'mx-0 [&>*:nth-of-type(1)]:text-xl',
        endIcon: 'mx-0 [&>*:nth-of-type(1)]:text-xl',
        outlinedSizeSmall: '',
        outlinedSizeMedium: 'h-[44px]',
        outlinedSizeLarge: 'h-[52px]',
      }}
    />
  );
});

export default COutlinedPrimaryButton;
